import { Checkbox } from "./primitive";
export default Checkbox;
